import screenbanner from "./images/background/1.jpg";
import mobilebanner from "./images/background/2.jpg";

import titanium from './images/property/titanium.webp'
import  Conscient_Parq from './images/property/conscientparq.webp'
import  Privana_North from './images/property/privananorth.webp'
import Privana_West from './images/property/privanawest.webp'
import Privana_South from "./images/property/privanasouth.webp";
import  Golf_Hills from './images/property/GolfHills.webp'
import Aspen_One from './images/property/aspen.webp'
import Aspen from "./images/property/aspen.webp";

export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};

export const LocationData = {
  taglineheading: "Property In SPR Road Gurugram",
  locationtag: "",
  location: [
    {
      name: "Signature Global - Titanium",
      image: titanium,
      price: "On Request",
      location: "Sector 71",
      bed: "3.5 - 4.5 BHK ",
      size: "....",
      url: `/signature-global-titanium`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "DLF - Privana North",
      image: Privana_North,
      price: "On Request",
      location: "Sector 77",
      bed: "4 BHK ",
      size: "....",
      url: `/gurugram/spr-road`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "DLF - Privana West",
      image: Privana_West,
      price: "On Request",
      location: "Sector 76",
      bed: "4 BHK ",
      size: "....",
      url: `/dlf-privana-west`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    // {
    //   name: "Whiteland - Aspen",
    //   image: Aspen,
    //   price: "On Request",
    //   location: "Gurugram-76",
    //   bed: "1 - 3 BHK Apartments",
    //   size: "On Request",
    //   url: `/whiteland-the-aspen`,
    // },
    {
      name: "Whiteland - Aspen One",
      image: Aspen_One,
      price: "On Request",
      location: "Sector 76",
      bed: "2 - 5 BHK ",
      size: "....",
      url: `/gurugram/spr-road`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "DLF - Privana South",
      image: Privana_South,
      price: "On Request",
      location: "Sector 77",
      bed: "1 - 3 BHK ",
      size: "....",
      url: `/dlf-privana-south`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "M3M - Golf Hills",
      image: Golf_Hills,
      price: "On Request",
      location: "Sector 79",
      bed: "3.5 BHK ",
      size: "....",
      url: `/gurugram/spr-road`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Conscient - Conscient Parq",
      image: Conscient_Parq,
      price: "On Request",
      location: "Sector 80",
      bed: "3 - 4 BHK ",
      size: "....",
      url: `/conscient-parq`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};